import type { z } from "zod";

import { idNameSchema } from "./generic-schema.ts";

// Get Request Schemas //
// Endpoint: /api/carrier-selection/carrier-price-types
export const carrierPriceTypeSchema = idNameSchema;

export type CarrierPriceType = z.infer<typeof carrierPriceTypeSchema>;
